import { createSlice } from "@reduxjs/toolkit"
const cartSlice= createSlice({
        name:"cart",
        initialState:{
            items:[],
        },
        reducers:{
            addItem:(state,action)=>{
                state.items.push(action.payload)
            },
            removeItem:(state,action)=>{
                const { id } = action.payload; // Assuming each item has an `id`
                state.items = state.items.filter(item => item?.card?.info?.id != id);
            },
            clearCart:(state,action)=>{
                state.items=[];
            }
        }
})

export const {addItem,removeItem,clearCart}=cartSlice.actions;
export default cartSlice.reducer;